export const authEndpoint = "https://accounts.spotify.com/authorize";
export const clientId = "3a73a562c583499ea19565fc3ebc4bcc";
export const redirectUri = "https://plotify-app.github.io/";
export const RESPONSE_TYPE = "token";
export const scopes = [
    "user-top-read",
];
